import { render, staticRenderFns } from "./DocumentGroupsCard.vue?vue&type=template&id=50922bf4&"
import script from "./DocumentGroupsCard.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports